/**
 * OAuth landing for the self-serve sign-up door (CLA-1032) — Clerk finishes the
 * redirect handshake here and sends the account on to the begin step.
 *
 * @since 1.0.0
 */
import { AuthenticateWithRedirectCallback } from "@clerk/tanstack-react-start";
import { createFileRoute } from "@tanstack/react-router";
import { SELF_SERVE_BEGIN_PATH } from "~/lib/self-serve-paths.ts";

export const Route = createFileRoute("/clawinstall/sign-up/sso-callback")({
  component: ClawInstallSignUpSSOCallback,
});

/**
 * Hands control back to Clerk; both fallbacks point at the begin step so a
 * returning account and a brand-new one land in the same place.
 *
 * @since 1.0.0
 */
export function ClawInstallSignUpSSOCallback() {
  return (
    <AuthenticateWithRedirectCallback
      signInFallbackRedirectUrl={SELF_SERVE_BEGIN_PATH}
      signUpFallbackRedirectUrl={SELF_SERVE_BEGIN_PATH}
    />
  );
}
